import { render, staticRenderFns } from "./ADdDeliveryBoy.vue?vue&type=template&id=29763c3c&"
import script from "./ADdDeliveryBoy.vue?vue&type=script&lang=js&"
export * from "./ADdDeliveryBoy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\laravel\\rawal\\rawal-laravel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29763c3c')) {
      api.createRecord('29763c3c', component.options)
    } else {
      api.reload('29763c3c', component.options)
    }
    module.hot.accept("./ADdDeliveryBoy.vue?vue&type=template&id=29763c3c&", function () {
      api.rerender('29763c3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/ADdDeliveryBoy.vue"
export default component.exports